<template>
  <base-layout>
    <breadcrumb :items="breadcrumbItems">
      <template v-slot:actions>
        <v-btn class="text-uppercase" color="primary" @click="newItem()">Novo Usuário</v-btn>
      </template>
    </breadcrumb>
    <v-container>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="q"
            label="Nome ou CPF"
            outlined
            dense
            hide-details
            clearable
            @click:clear="cleanSearch()"
            v-on:keyup.enter="userSearch()"
          />
        </v-col>
        <v-col cols="2">
          <v-btn @click="userSearch()" :loading="loading" rounded fab small>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="items"
            :items-per-page="15"
            :options.sync="pagination"
            class="elevation-1"
            :footer-props="{
              itemsPerPageOptions: footerProps.itemsPerPageOptions,
              itemsPerPageText: footerProps.itemsPerPageText
            }"
          >
            <template v-slot:item.active="{ item }">
              <v-checkbox disabled v-model="item.active"></v-checkbox>
            </template>
            <template v-slot:item.roles="{ item }">{{ getParsedRoles(item.roles) }}</template>

            <template v-slot:item.actions="{ item }">
              <v-btn fab text x-small @click="editItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" fab text x-small @click="resetPassword(item)">
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                </template>
                <span>Redefinir senha</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <create-or-update-user
      :dialog="createOrUpdateDialog"
      :selectedUser="selectedItem"
      @closeDialog="closeDialog($event)"
    />
  </base-layout>
</template>

<script>
import BaseLayout from '@/layouts/BaseLayout';
import Breadcrumb from '@/components/base/Breadcrumb';
import CreateOrUpdateUser from '@/components/configurations/users/CreateOrUpdateUser';
import UserServices from '@/services/users-service';
import { mapActions } from 'vuex';
import { get } from 'lodash';
import { apiResponseMixin } from '@/mixins';
import usersService from "../../../services/users-service";

export default {
  name: 'users-list',
  components: { BaseLayout, Breadcrumb, CreateOrUpdateUser },
  mixins: [apiResponseMixin],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      get,
      breadcrumbItems: [
        {
          text: 'Usuários',
          disabled: true
        }
      ],
      headers: [
        {
          text: 'Nome',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'CPF',
          align: 'start',
          sortable: false,
          value: 'cpf'
        },
        {
          text: 'E-mail',
          align: 'start',
          sortable: false,
          value: 'email'
        },
        {
          text: 'Telefone',
          align: 'start',
          sortable: false,
          value: 'phone'
        },
        {
          text: 'Ativo?',
          align: 'start',
          sortable: false,
          value: 'active'
        },
        {
          text: 'Perfil',
          align: 'start',
          sortable: false,
          value: 'roles'
        },
        {
          text: 'Ações',
          align: 'start',
          sortable: false,
          value: 'actions'
        }
      ],
      items: [],
      footerProps: {
        itemsPerPageOptions: [15, 20, 30],
        itemsPerPageText: 'Itens por página'
      },
      loading: false,
      createOrUpdateDialog: false,
      q: '',
      selectedItem: {},
      pagination: {
        page: 1,
        itemsPerPage: 15
      },
      rolesTypes: {
        super_admin: 'Super Admin',
        admin: "Admin",
        regulator: "Regulador",
        videophonist: "Videofonista",
        supervisor: "Supervisor",
        coordinator_regulation: "Coordenador de Regulação"
      }
    };
  },
  methods: {
    ...mapActions('base', ['showSnackbar']),
    fetch() {
      const payload = {
        q: this.q,
        page: this.pagination.page,
        items_per_age: this.pagination.itemsPerPage
      };
      this.loading = true;
      UserServices.all(payload)
        .then(({ data }) => {
          this.items = data.users;
        })
        .catch(err => {
          console.log(err);
          this.handleApiErrorResponse(err, 'Erro inesperado ao listar os usuários, tente novamente mais tarde');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cleanSearch() {
      this.q = '';
      this.fetch();
    },
    editItem(item) {
      this.selectedItem = item;
      this.createOrUpdateDialog = true;
    },
    newItem() {
      this.selectedItem = {};
      this.createOrUpdateDialog = true;
    },
    closeDialog(payload) {
      this.createOrUpdateDialog = false;
      if (payload.forceRefresh) {
        this.fetch();
      }
    },
    getParsedRoles(roles) {
      const userRoles = new Set(roles.map(role => this.rolesTypes[role.role_type]));
      return Array.from(userRoles).join(', ');
    },
    resetPassword(user) {
      usersService
        .resetPassword(user.id)
        .then(() => {
          this.showSnackbar({ show: true, message: 'Senha atualiza para o CPF do usuário (apenas os números)', color: 'success' });
        })
        .catch(() => {
          this.showSnackbar({ show: true, message: 'Não foi possível atualizar a senha do usuário', color: 'error' });
        })
    },
    userSearch() {
      this.pagination.page = 1;
      this.fetch();
    }
  },
  computed: {},
  watch: {
    options: {
      handler(newValue) {
        this.pagination = {
          page: newValue.page,
          itemsPerPage: newValue.itemsPerPage
        };
        this.fetch();
      },
      deep: true
    }
  }
};
</script>
